<template>

    <footer class="g-bg-main g-pt-100 g-pb-50">


      <div class="container">
        <div class="row g-mb-40">
          <div class="col-6 col-md-3 g-mb-20" v-if="CheckLogin()">
            <!-- Footer Links -->
            <b class="g-font-size-18 g-color-footer-links">Pages</b>
            <ul class="list-unstyled g-mt-20">
              <li class="g-py-5"><a v-on:click="RouterRedirect('Home')" class="hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16">Home</a></li>
              <li class="g-py-5"><a v-on:click="RouterRedirect('Order')" class="hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16">Order Now</a></li>
              <li class="g-py-5"><a v-on:click="RouterRedirect('OrderTracking')" class="hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16">Track Orders</a></li>
              <li class="g-py-5"><a v-on:click="RouterRedirect('Frames')" class="hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16">Frames</a></li>
              <li class="g-py-5"><a v-on:click="RouterRedirect('Resources')" class="hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16">Resources</a></li>
              <li class="g-py-5"><a v-on:click="RouterRedirect('UserAccount')" class="hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16">My Account</a></li>
              <li class="g-py-5"><a v-on:click="RouterRedirect('Help')" class="hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16">Help</a></li>
            </ul>
            <!-- End Footer Links -->
          </div>
          <div class="col-6 col-md-3 g-mb-20">
            <!-- Footer Links -->
            <b class="g-font-size-18 g-color-footer-links">Links and More</b>
            <ul class="list-unstyled g-mt-20">
              <!--<li class="g-py-5"><a class="hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17" target="_blank" href="http://www.EssilorUSA.com">Essilor USA</a></li>-->
              <li class="g-py-5"><a class="hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17" target="_blank" href="http://www.onesight.essilorluxottica.com">OneSight EssilorLuxottica Foundation</a></li>
              <li class="g-py-5"><a class="hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17" target="_blank" href="https://www.evfusa.org/terms-and-conditions">Terms of Use</a></li>
              <li class="g-py-5"><a class="hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17" target="_blank" href="http://www.evfusa.org/privacy-policy">Privacy Policy</a></li>
              <li class="g-py-5"><a class="hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17" target="_blank" href="http://www.evfusa.org/disclosures">Disclosures</a></li>
              <li class="g-py-5"><a class="hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17" target="_blank" href="https://www.essilorusa.com/about/ethics-compliance">Ethics & Compliance</a></li>
            </ul>
            <!-- End Footer Links -->
          </div>
          <div class="col-6 col-md-3 g-mb-20" v-if="!CheckLogin()">
            <!-- column 3  -->
            <!-- column 3 -->
          </div>
          <div class="col-12 col-md-6 g-mb-20">
            <!-- Column 4 -->
            <img class="evf-watermark-2" src="/static/assets/img/logo/Powered_by_OSELF-white.png" />

            <ul class="list-inline mb-0 evf-social-2 g-my-10">
              <li class="list-inline-item g-mx-4">
                <a class="u-icon-v1 u-icon-size--xs u-shadow-v32" href="https://www.facebook.com/onesight/">
                  <img src="/static/onesight/white-facebook.png" class="social-media__icon" alt="facebook">
                </a>
              </li>
              <li class="list-inline-item g-mx-4">
                <a class="u-icon-v1 u-icon-size--sm u-shadow-v32" href="https://www.linkedin.com/company/onesightessilorluxotticafoundation">
                  <img src="/static/onesight/white-linkedin.png" class="social-media__icon" alt="linkedin">
                </a>
              </li>
              <li class="list-inline-item g-mx-4">
                <a class="u-icon-v1 u-icon-size--xs u-shadow-v32" href="https://twitter.com/onesightorg">
                  <img src="/static/onesight/white-twitter.png" class="social-media__icon" alt="twitter">
                </a>
              </li>
              <li class="list-inline-item g-mx-4">
                <a class="u-icon-v1 u-icon-size--sm u-shadow-v32" href="https://www.instagram.com/onesight/">
                  <img src="/static/onesight/white-instagram.png" class="social-media__icon" alt="instagram">
                </a>
              </li>

            </ul>

            <!-- End Column 4 -->
          </div>
        </div>
        <!-- Footer Copyright -->

        <div class="col-sm-6 col-md-4 col-lg-3 order-md-2 g-mb-30">
          <!-- Social Icons -->
          <!-- End Social Icons -->
        </div>
        <div class="col-md-4 col-lg-3 order-md-1 g-mb-30">

        </div>
      </div>
      <!-- End Footer Copyright -->
  </div>
  </footer>
  <!-- End Footer -->
</template>
<script>
export default {
  methods: {
    CheckLogin(){
      var token = localStorage.getItem("token");
      if(token){
        return true;
      }
      else{
        return false;
      }
    },
    RouterRedirect(name){
      var href = window.location.href;
      if(href[href.length - 1] == "/")
        window.location.href = '../' + name + '/';
      else
        window.location.href = href+'/../' + name + '/';
    }
  }
}

  </script>

<style>

  .social-media__icon {
    height: 100%;
    opacity: 0.8;
    cursor: pointer;
  }
  .social-media__icon:hover {
    opacity: 1;
  }

</style>


// WEBPACK FOOTER //
// FooterComponent.vue?32dbdde6